import { Directive, effect, inject, input } from '@angular/core';
import { StrakitSelectComponent } from '@ngx-strakit/cdk/controls';
import { sortLocaleCompareByFn } from '@iris/common/utils/array.utils';

@Directive({
  selector: 'sk-select[skSelectSortItems]',
})
export class SortItemsDirective<T extends Record<string, unknown>> {
  private readonly select = inject(StrakitSelectComponent);

  items = input<T[]>([]);

  sortItems = effect(() => {
    const data = this.items();
    if (!data || data.length === 0) return;

    const bindLabel = (this.select.bindLabel as keyof T) || (this.select.bindValue as keyof T) || ('id' as keyof T);

    this.select.items = [...data].sort(sortLocaleCompareByFn(bindLabel));
    this.select.refreshItems();
  });
}
